import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/App';

import * as serviceWorker from './serviceWorker';
import configureStore from './redux/configureStore';
import { Provider as ReduxProvider } from 'react-redux';
import { fetchUser } from './redux/authActions';
import { fetchProducts, fetchCompanies } from './redux/marketplaceActions';

const store = configureStore();

store.dispatch(fetchUser());
store.dispatch(fetchProducts());
store.dispatch(fetchCompanies());

ReactDOM.render(
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
